document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu
  var btn = document.getElementById('mobile-btn');
  var nav = document.getElementById('mobile-nav');
  var close = document.getElementById('mobile-close');
  if (btn) btn.addEventListener('click', function(){ nav.classList.toggle('open'); });
  if (close) close.addEventListener('click', function(){ nav.classList.remove('open'); });

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Services dropdown touch support
  document.querySelectorAll('.has-dropdown > a, .has-dropdown > button').forEach(function(el){
    el.addEventListener('click', function(e){
      if (window.innerWidth <= 768) {
        e.preventDefault();
        el.parentElement.classList.toggle('active');
      }
    });
  });
});
